import { AgendamentoTransporteProduto } from "@/types/agendamento_transporte_produto";

export const novoAgendamentoTransporteProduto = (): AgendamentoTransporteProduto => {
  return {
    nome: '',
    agendamento_transporte_ukey: '',
    data_validade: '',
    laudo: '',
    lote: '',
    quantidade: 0,
  }
}